/* import __COLOCATED_TEMPLATE__ from './sq-input-search.hbs.js'; */
var _dec, _dec2, _dec3, _class, _class2, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import { classNames, classNameBindings } from '@ember-decorators/component';
import { readOnly } from '@ember/object/computed';
/**
## Input Search

SqInputSearch is a text field that sends an event when the search text changes.

```example
@title Basic Usage

@hbs
{{sq-input-search onChange=(action (mut value))}}

Value: {{value}}
```

```example
@title Usage with fluid width

@hbs
{{sq-input-search onChange=(action (mut value))
                  isFluid=true}}

Value: {{value}}
```

### Parameters
 * @param {action} [onChange] [An action that gets triggered when the text changes]
 * @param {String} [searchText] [The text in the component that is being searched for]
 * @param {String} [placeholderText] [The placeholder text]
 * @param {Number} [liveTypingDelay=150] [The time (in ms) that the component waits for additional input before firing the onChange action]
 * @param {Boolean} [isFluid] [The width of the search box should be maximized]

*/

import { debounce } from '@ember/runloop';
import Component from '@ember/component';
export const DEFAULT_SEARCH_KEYPRESS_DELAY = 150; // ms
let SqInputSearch = (_dec = classNames('input-icon', 'input-search'), _dec2 = classNameBindings('isFluid:input-search--fluid'), _dec3 = readOnly('searchText'), _dec(_class = _dec2(_class = (_class2 = class SqInputSearch extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, 'data-test-input-search', _descriptor, this);
    _defineProperty(this, "searchText", null);
    _defineProperty(this, "prevSearchText", null);
    _defineProperty(this, "placeholderText", null);
    _defineProperty(this, "isFocused", false);
    _defineProperty(this, "isFluid", false);
    _defineProperty(this, "disabled", false);
    _defineProperty(this, "liveTypingDelay", DEFAULT_SEARCH_KEYPRESS_DELAY);
  }
  init(...args) {
    super.init(...args);
    this.set('prevSearchText', this.searchText);
  }
  focusIn(...args) {
    this.set('isFocused', true);
    if (this.onFocusIn) {
      this.onFocusIn(...args);
    }
  }
  focusOut(...args) {
    this.set('isFocused', false);
    if (this.onFocusOut) {
      this.onFocusOut(...args);
    }
  }

  // debounce while typing
  input() {
    debounce(this, this.debouncedOnSearchTextChanged, this.liveTypingDelay, false);
  }

  // fire immediately on blur (should be no-op most of the time because
  // the action already fired on input)
  change() {
    this.onSearchTextChanged();
  }
  debouncedOnSearchTextChanged() {
    this.onSearchTextChanged();
  }

  // send the event only if the text actually
  // changes to account for the two event types
  onSearchTextChanged() {
    const newText = this.searchText || '';
    const oldText = this.prevSearchText || '';
    if (!this.isDestroyed) {
      if (newText !== oldText) {
        this.onChange?.(newText);
      }
      this.set('prevSearchText', newText);
    }
  }
  clearSearch() {
    this.set('searchText', null);
    this.onSearchTextChanged(null);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'data-test-input-search', [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "clearSearch", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "clearSearch"), _class2.prototype)), _class2)) || _class) || _class);
export { SqInputSearch as default };